import {
	Intro,
	Terminals,
	Window,
	Header,
	Left,
	ThatShitInTopLeftCorner,
	Explorer,
	IDE,
	Code,
	TerminalText,
	Padding,
	OverFlowAuto,
	AboutMe,
	AboutMeTitle,
	AboutMeDescription,
	Line,
	SubTitle,
	SubSubTitle,
	Footer,
    IconsRow
} from "../Utils/styles";

import TypingEffect from "../Utils/TypingEffect";
import _react, { useState, useEffect, useRef } from "react";
import MyNameIsCodeIn from "../Utils/Code";

import { SiDiscord } from "react-icons/si";
import { FaSteam, FaGithub, FaInstagram } from "react-icons/fa";

let timeoutMap = [];

export default function App() {
	const [lang, setLang] = useState("js");
	const [consoleText, setConsoleText] = useState(
		<li>{"PS C:\\Users\\You\\JavaScript> "}</li>
	);
	const [outputText, setOutputText] = useState(<li></li>);
	const [moreText, setMoreText] = useState(<li></li>);
	const [bruhAnotherText, setAnotherText] = useState(false);
	const [code, setCode] = useState(<></>);

	useEffect(() => {
		for (const timeout of timeoutMap) clearTimeout(timeout);
		timeoutMap = [];

		const baseText =
			"PS C:\\Users\\You\\" +
			(() => {
				switch (lang) {
					case "ts":
						return "TypeScript";
					case "js":
						return "JavaScript";
					case "rs":
						return "Rust";
					case "cs":
						return "Csharp";
				}
			})() +
			"> ";

		setOutputText(<li></li>);
		setConsoleText(<li>{baseText}</li>);
		setMoreText(<li></li>);
		setAnotherText(false);

		timeoutMap.push(
			setTimeout(() => {
				setConsoleText(
					<TypingEffect
						text={(() => {
							switch (lang) {
								case "ts":
									return "tsc src/aboutme.ts | node src/aboutme.js";
								case "js":
									return "node src/aboutme";
								case "rs":
									return "cargo run";
								case "cs":
									return "dotnet run";
							}
						})()}
						baseText={baseText}
						delay={30}
					/>
				);

				timeoutMap.push(
					setTimeout(
						() => {
							setOutputText(<li>Hello, my name is </li>);

							timeoutMap.push(
								setTimeout(async () => {
									await setOutputText(
										<TypingEffect
											text={"Redable"}
											baseText={"Hello, my name is "}
											delay={50}
										/>
									);

									timeoutMap.push(
										setTimeout(() => {
											setMoreText(<li>{baseText}</li>);
											timeoutMap.push(
												setTimeout(() => {
													setMoreText(
														<TypingEffect
															text={"cd .. | more aboutme.txt"}
															baseText={baseText}
															delay={30}
														/>
													);

													timeoutMap.push(
														setTimeout(() => {
															setAnotherText(true);
														}, 1000)
													);
												}, 2000)
											);
										}, 1000)
									);
								}, 3000)
							);
						},
						lang === "ts" ? 1500 : 1000
					)
				);
			}, 2000)
		);
	}, [lang]);

	useEffect(() => {
		setCode(
			(() => {
				switch (lang) {
					case "ts":
					case "js":
						return MyNameIsCodeIn.jsts;
					case "rs":
						return MyNameIsCodeIn.rs;
					case "cs":
						return MyNameIsCodeIn.cs;
					default:
						return <h1>hehee</h1>;
				}
			})()
		);
	}, [lang]);

	const isSelected = (ylang) => ylang === lang;

	return (
		<>
			<main>
					<Intro>
						<Terminals>
							<Window>
								<Header>
									<Padding>
										<Left>
											<ThatShitInTopLeftCorner>
												<li>🔴</li>
												<li>🟠</li>
												<li>🟢</li>
											</ThatShitInTopLeftCorner>
										</Left>
									</Padding>
								</Header>
								<IDE>
									<Explorer>
										<ul>
											<li
												className={isSelected("js") ? "selected" : ""}
												onClick={() => setLang("js")}
											>
												.js
											</li>
											<li
												className={isSelected("ts") ? "selected" : ""}
												onClick={() => setLang("ts")}
											>
												.ts
											</li>
											<li
												className={isSelected("rs") ? "selected" : ""}
												onClick={() => setLang("rs")}
											>
												.rs
											</li>
											<li
												className={isSelected("cs") ? "selected" : ""}
												onClick={() => setLang("cs")}
											>
												.cs
											</li>
										</ul>
									</Explorer>
									<Code className="text">{code}</Code>
								</IDE>
							</Window>
							<Window>
								<Header>
									<Padding>
										<Left>
											<ThatShitInTopLeftCorner>
												<li>🔴</li>
												<li>🟠</li>
												<li>🟢</li>
											</ThatShitInTopLeftCorner>
										</Left>
									</Padding>
								</Header>
								<OverFlowAuto>
									<TerminalText className="text">
										<li>Welcome Page</li>
										<li>Copyright (C) Redable. All rights reserved.</li>
										<br />
										{consoleText}
										<br />
										{outputText}
										<br />
										{moreText}
										{bruhAnotherText ? (
											<>
												<br />
												<li>
													See more informations about me by scrolling down :)
												</li>
												<li>{"PS C:\\Users\\You> "}</li>
											</>
										) : (
											<></>
										)}
									</TerminalText>
								</OverFlowAuto>
							</Window>
						</Terminals>
					</Intro>
				<AboutMe>
						<AboutMeTitle>About Me</AboutMeTitle>
								<AboutMeDescription>
									Hi, I'm young developer from Czech republic, studying IT. I
									started in the end of 2019 with creating discord bots{" "}
									<a href="https://discord.js.org/">(discord.js)</a> with{" "}
									<a href="https://javascript.info/">JavaScript</a>. In the
									middle of 2020 I've learned framework{" "}
									<a href="https://expressjs.com/">Express</a> for creating
									webservers, but nobody wants to see peace of JSON, so I
									learned <a href="https://en.wikipedia.org/wiki/HTML">Html</a>+
									<a href="https://en.wikipedia.org/wiki/CSS">Css</a> and found
									my favorite library for building UI,{" "}
									<a href="https://reactjs.org/">React</a>. At the beginning of
									2021 I wanted to learn another programming language. I tried{" "}
									<a href="https://www.python.org/">Python</a>,{" "}
									<a href="https://dotnet.microsoft.com/learn/csharp">C#</a> and{" "}
									<a href="https://www.rust-lang.org/">Rust</a> and decided to
									learn <a href="https://www.rust-lang.org/">Rust</a>. But I
									started studying IT so I'm learning{" "}
									<a href="https://dotnet.microsoft.com/learn/csharp">C#</a>{" "}
									anyway. And right now (End of 2021), I'm not creating discord
									bots anymore, still creating websites with{" "}
									<a href="https://reactjs.org/">React</a> and{" "}
									<a href="https://styled-components.com/">styled components</a>{" "}
									and I'm still using <a href="https://www.rust-lang.org/">Rust</a>.
								</AboutMeDescription>
						<Line />
						<SubTitle>Projects</SubTitle>
						<AboutMeDescription>
							I never made any big project, that was public. 
							Almost every my project is stored in Github and there isn't any plan to modify them. 
							The most successful public poject was discord bot called BafBot. 
						</AboutMeDescription>
						<SubSubTitle>BafBot</SubSubTitle>
						<AboutMeDescription>
							BafBot was multipurpose discord bot with 100+ commands, written in Javascript. It used Discord.js for interacting with discord and mongoose for database. 
							Development of bot started around in may 2020 and application was deleted in 13.09.2021. 
							At first, bot was hosted on Glitch. Later on, glitch decided to not collaborate with me, so I switched to Replit. 
							Before deleting (Based of cached data), bot was on 41 servers with total 10816 users.
							

						</AboutMeDescription>
						<Line />
						<IconsRow>
                                        <SiDiscord
                                            onClick={()=>alert("Redable#5010")}
                                        />
                                        <FaSteam
                                            onClick={()=>window.open("https://steamcommunity.com/id/readablesgamercz/")}
                                        />
                                        <FaGithub
                                            onClick={()=>window.open("https://github.com/ReadableCZE")}
                                        />
										<FaInstagram
                                            onClick={() =>window.open("https://www.instagram.com/_redable/")}
                                        />
                                    </IconsRow>
				</AboutMe>
				
				<Footer>
					Website made by me with 💙
				</Footer>
			</main>

		</>
	);
}
